import _ from "lodash";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { Theme, useTheme } from "@mui/material";
import { Tooltip } from "@shared/Tooltip";
import { CellContext } from "@tanstack/react-table";

import { GroupOverviewData } from "../../GroupPage.utils";

const useStyles = makeStyles<{ color: string }>()((theme: Theme, { color }) => ({
    tooltip: {
        display: "flex",
        justifyContent: "center",
        marginRight: theme.spacing(1),
    },
    icon: {
        color,
        display: "inline-block",
        verticalAlign: "middle",
    },
}));

export const OnlineStatusIcon = (props: CellContext<GroupOverviewData, unknown>) => {
    const { t } = useTranslation(["pages"]);
    const value = _.toNumber(_.trimEnd(props.getValue<string>(), "%"));
    const theme = useTheme();
    const groupIsEmpty = props.row.original.onlineDevicePercentage === "";
    const hasOfflineDevices = props.row.original.onlineDevicePercentage && value < 100;

    let iconClassName;
    let color;
    let tooltipText;

    if (groupIsEmpty) {
        iconClassName = "fa-regular fa-circle";
        color = theme.palette.emteria.text.secondary;
        tooltipText = t("pages:groupPage.tooltip.groupIsEmpty");
    } else if (hasOfflineDevices) {
        iconClassName = "fa-solid fa-circle-exclamation";
        color = theme.palette.emteria.warning;
        tooltipText =
            value === 0 ? t("pages:groupPage.tooltip.allDevicesOffline") : t("pages:groupPage.tooltip.someDevicesOffline");
    } else {
        iconClassName = "fa-solid fa-circle-check";
        color = theme.palette.emteria.success;
        tooltipText = t("pages:groupPage.tooltip.allDevicesOnline");
    }

    const { classes } = useStyles({ color });

    return (
        <Tooltip title={tooltipText} className={`${classes.tooltip}`}>
            <span className={classes.icon}>
                <i className={iconClassName} />
            </span>
        </Tooltip>
    );
};
